import { makeStyles } from '../../../styles';
export const useWizardContentHeaderStyles = makeStyles((theme) => ({
    root: {
        fontFamily: theme.typography.fontFamily,
        width: 550,
    },
    headerText: {
        color: theme.colors.text[900],
    },
    subHeaderText: {
        color: theme.colors.gray[800],
        marginTop: 5,
        marginRight: 3,
        marginBottom: theme.spacing(4.25),
        display: 'inline-block',
    },
    hrefText: {
        fontWeight: 'normal',
    },
}));
//# sourceMappingURL=WizardContentHeader.styles.js.map